export enum TransmissionEnum {
  AUTO = 'AUTO',
  MANUAL = 'MANUAL',
}

export enum FuelTypeEnum {
  AI100 = 'AI100',
  AI92 = 'AI92',
  AI95 = 'AI95',
  AI98 = 'AI98',
  DIESEL = 'DIESEL',
  METHANE = 'METHANE',
  PROPANE = 'PROPANE',
  ELECTRICITY = 'ELECTRICITY',
}

export enum CarTariffEnum {
  ECONOMY = 'ECONOMY',
  BUSINESS = 'BUSINESS',
}

export enum RentalContractWorkScheduleEnum {
  FULL_WEEK = '7/0',
  SIX_THROUGH_ONE = '6/1',
}

export enum RentalContractQuantityOfHoursEnum {
  ONE_WRITE_OFF = 1,
  TWO_WRITE_OFF = 2,
  TWELVE_WRITE_OFF = 12,
}

export enum RentalStatusEnum {
  IN_PROGRESS = 'IN_PROGRESS',
  APPROVED = 'APPROVED',
}

export enum AcceptanceDocumentTypeEnum {
  DriverPersonalData = 'DriverPersonalData',
  PublicOffer = 'PublicOffer',
}

export enum MoveFundsType {
  COMING = 'COMING',
  SPENDING = 'SPENDING',
}

export enum RentalContractStatusEnum {
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  SIGNING = 'SIGNING',
  SIGNED = 'SIGNED',
  CANCELLATION_IN_PROGRESS = 'CANCELLATION_IN_PROGRESS',
}

export enum SupportCmsBlockEnum {
  ADDRESS_AND_CONTACTS = 'address_and_contacts',
  CAR_NOT_START = 'car_not_start',
  BREAKDOWN_ON_ROAD = 'breakdown_on_road',
  DOCUMENTS = 'documents',
  TRAFFIC_POLICE_FINES = 'traffic_police_fines',
  EUROPEAN_PROTOCOL = 'european_protocol',
  ROAD_ACCIDENT = 'road_accident',
}

export enum ContactMethodEnum {
  phone = 'phone',
  telegram = 'telegram',
}

export enum DayEnum {
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
}

export enum CarEquipmentTypeEnum {
  EXTERIOR = 'EXTERIOR',
  INTERIOR = 'INTERIOR',
  TRUNK = 'TRUNK',
}

export enum DocumentsTypeEnum {
  STS = 'STS',
  OSAGO = 'OSAGO',
  DC = 'DC',
  LICENSE = 'LICENSE',
}

export enum CarDetailTypeEnum {
  EXTERIOR = 'EXTERIOR',
  INTERIOR = 'INTERIOR',
  TIRE = 'TIRE',
  ENVIRONMENT = 'ENVIRONMENT',
}

export enum CarDamageExtendsCodeEnum {
  LIGHT = 'LIGHT',
  MEDIUM = 'MEDIUM',
  HEAVY = 'HEAVY',
}

export enum InspectionPhotoTypeEnum {
  CAR = 'car',
  TARIFFS = 'tariffs',
  LAST_TO = 'lastTO',
  MILEAGE = 'mileage',
  DAMAGE = 'damage',
  DRIVER_SIGNATURE = 'driverSignature',
}

export enum DriverStatusEnum {
  CHECKING = 'CHECKING',
  REJECTED = 'REJECTED',
  CREATED = 'CREATED',
  CHECKS_STARTING = 'CHECKS_STARTING',
  REJECT_IN_PROGRESS = 'REJECT_IN_PROGRESS',
  APPROVE_IN_PROGRESS = 'APPROVE_IN_PROGRESS',
  APPROVED = 'APPROVED',
  CHECKS_FINISHED = 'CHECKS_FINISHED',
  CHECKS_CANCELLED = 'CHECKS_CANCELLED',
  SENDING_TO_COMANDIR = 'SENDING_TO_COMANDIR',
  SENT_TO_COMANDIR = 'SENT_TO_COMANDIR',
  CHECKS_CANCELLATION_REQUESTED = 'CHECKS_CANCELLATION_REQUESTED',
  ONBOARDING_STARTING = 'ONBOARDING_STARTING',
  ONBOARDING_STARTED = 'ONBOARDING_STARTED',
  REJECT_REQUESTED = 'REJECT_REQUESTED',
  APPROVE_REQUESTED = 'APPROVE_REQUESTED',
  CHECKS_RETRY_REQUESTED = 'CHECKS_RETRY_REQUESTED',
  ADDITIONAL_APPROVAL_REQUESTED = 'ADDITIONAL_APPROVAL_REQUESTED',
  WORKS = 'WORKS',
  FIRED = 'FIRED',
  CHECKS_EXPIRED = 'CHECKS_EXPIRED',
}

export enum MainTaxiparkCmsBlock {
  MAIN_TAXIPARK_CMS_LINK = 'main_taxipark_cms_link',
}

export enum TimezoneCode {
  KALININGRAD = 'Europe/Kaliningrad', // UTC+2
  MOSCOW = 'Europe/Moscow', // UTC+3
  SAMARA = 'Europe/Samara', // UTC+4
  YEKATERINBURG = 'Asia/Yekaterinburg', // UTC+5
  OMSK = 'Asia/Omsk', // UTC+6
  KRASNOYARSK = 'Asia/Krasnoyarsk', // UTC+7
  IRKUTSK = 'Asia/Irkutsk', // UTC+8
  YAKUTSK = 'Asia/Yakutsk', // UTC+9
  VLADIVOSTOK = 'Asia/Vladivostok', // UTC+10
  MAGADAN = 'Asia/Magadan', // UTC+11
  KAMCHATKA = 'Asia/Kamchatka', // UTC+12
}

export enum RentalServiceCmsBlock {
  RENTAL_SERVICES_MORE_DRAWER = 'rental_services_more_drawer',
  RENTAL_SERVICES_SECOND_MORE_DRAWER = 'daily_debit_shedule_drawer',
}

export enum CarAccessControlEnum {
  UNLOCK = 'UNLOCK',
  LOCK = 'LOCK',
}

export enum DebtStatusesEnum {
  PROCESSING = 'PROCESSING',
  PAID = 'PAID',
  SUSPENDED = 'SUSPENDED',
}

export enum DebtSourceTypesEnum {
  INSPECTION_VIOLATIONS = 'INSPECTION_VIOLATIONS',
  INSPECTION_DAMAGES = 'INSPECTION_DAMAGES',
  PLAN_INSPECTION_DELAY = 'PLAN_INSPECTION_DELAY',
  EXTERNAL_PENALTY = 'EXTERNAL_PENALTY',
  BALANCE_CORRECTION = 'BALANCE_CORRECTION',
  TOLL_ROAD = 'TOLL_ROAD',
  REDEMPTION_PAYMENT = 'REDEMPTION_PAYMENT',
  OSAGO = 'OSAGO',
  TIRES = 'TIRES',
  AUTO_TRANSMISSION = 'AUTO_TRANSMISSION',
  GBO = 'GBO',
  SERVICE = 'SERVICE',
  OTHER_CHARGES = 'OTHER_CHARGES',
}

export enum InfoSourceEnum {
  RECOMMENDATION = 'RECOMMENDATION',
  PREVIOUS_WORK = 'PREVIOUS_WORK',
  AVITO = 'AVITO',
  CAR_ADVERTISEMENT = 'CAR_ADVERTISEMENT',
  TELEGRAM = 'TELEGRAM',
  LEAFLET = 'LEAFLET',
  YANDEX_MAPS = 'YANDEX_MAPS',
  YANDEX_GARAGE = 'YANDEX_GARAGE',
  BROWSER_ADVERTISEMENT = 'BROWSER_ADVERTISEMENT',
  PASSED_BY = 'PASSED_BY',
  SITE = 'SITE',
}

export enum TaxSystemEnum {
  OSN = 'OSN',
  USN = 'USN',
  AUSN = 'AUSN',
  OSNP = 'OSNP',
  USNP = 'USNP',
}

export enum AggregatorOccupationCodeEnum {
  park_employee = 'park_employee',
  self_employed_rus = 'self_employed_rus',
  individual_entrepreneur_rus = 'individual_entrepreneur_rus',
}

export enum NotificationTokenTypes {
  firebase = 'firebase',
  rustore = 'rustore',
}

export enum IdentityRecognitionDocumentEnum {
  passport = 'passport',
  driverLicense = 'driver_license',
}

export enum IdentityRecognitionFileEnum {
  passport = 'passport',
  driverLicenseFront = 'driver-license-front',
  driverLicenseBack = 'driver-license-back',
}
